import { useState } from "react";
import "../App.css";


import * as React from "react";

import RadioGroup from "@mui/joy/RadioGroup";
import List from "@mui/joy/List";
import ListItem from "@mui/joy/ListItem";
import ListItemDecorator from "@mui/joy/ListItemDecorator";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import Radio, { radioClasses } from "@mui/joy/Radio";
import FormControl from "@mui/material/FormControl";


import getCharacteristicsImagePath from "../services/image/imageService.js";

/**
 * The Generic RadioEnum Component
 * @param {String Representation of the enum typewe are trying to select}
 * @returns
 */
export default function EventEnumRadioSelector({
  enumType,
  enumList,
  initValue,
  onEvent,
  selectionRequired,
  selectorSize,
  disabled
  
  
}) {
  

  const [radioValue, setRadioValue] = useState(initValue); 

  const updateSelection = async (event) => {
    let enumValue = event.target.value;
    if (radioValue !== enumValue) {
      onEvent(event, enumType, enumValue);
      setRadioValue(enumValue);
    }else if(!selectionRequired){
      event.target.checked = false;
      setRadioValue(null);
      onEvent(event, enumType, null);
    }
    
  };

  function isChecked(value) {
    return value === radioValue;
  }
  

  return (
    <FormControl disabled={disabled}>
      <RadioGroup
        aria-label="Your plan"
        value={radioValue}
        name="people"
        sx={{
          flexDirection: "row",
          gap: 2,
          [`& .${radioClasses.checked}`]: {
            [`& .${radioClasses.action}`]: {
              inset: -1,
              border: "3px solid",
              borderColor: "primary.500",
            },
          },
          [`& .${radioClasses.radio}`]: {
            display: "contents",
            "& > svg": {
              zIndex: 2,
              position: "absolute",
              top: "-8px",
              right: "-8px",
              bgcolor: "background.body",
              borderRadius: "50%",
            },
          },
        }}
      >
        <List
          orientation="horizontal"
          sx={{
            minWidth: 0,
            "--List-gap": "0.5rem",
            "--ListItem-paddingY": "1rem",
            "--ListItem-paddingX": "0.25rem",
            "--ListItem-radius": "8px",
            "--ListItemDecorator-size": "32px",
          }}
        >
          {enumList.map((value, index) => (
            <ListItem
              variant="outlined"
              key={value}
              sx={{
                width: selectorSize,
                height: selectorSize,
                boxShadow: "sm",
                backgroundColor: "red",
                bgcolor: "background.body",
              }}
              value={value}
            >
              <ListItemDecorator>
                <img
                  height={selectorSize - 10}
                  alt=""
                  src={getCharacteristicsImagePath(enumType, value)}
                  sx={{ width: selectorSize - 20, height: selectorSize - 20 }}
                />
              </ListItemDecorator>

              <Radio
                disabled={disabled}
                id={enumType}
                checkedIcon={<CheckCircleRoundedIcon />}
                overlay
                value={value}
                onClick={updateSelection}
                name={value}
                checked={isChecked(value)}
                sx={{
                  color: "black",
                  flexGrow: 1,
                  flexDirection: "row-reverse",
                }}
                slotProps={{
                  action: ({ checked }) => ({
                    sx: (theme) => ({
                      ...(checked && {
                        inset: 2,
                        border: "3px solid",
                        borderColor: "#2d3e50",
                      }),
                    }),
                  }),
                }}
              />
            </ListItem>
          ))}
        </List>
      </RadioGroup>
    </FormControl>
  );
}

// <Avatar alt="TEST" src={process.env.PUBLIC_URL + '/images/icons8-tick-60.png'} sx={{ width: 30, height: 30 }}/>
